export default {
    home: {
      webPage: '111',
      picture: 'Picture',
      noPage: 'There are currently no pages available',
      close:'Close',
      reback:'Back',
      subMit:'Submit',
      informationFeedback:'Information Feedback',
      about:'About Us',
      homePage:'Home Page',
      userName:'Name',
      address:'address',
      telephone:'telephone',
      cellphone:'cell phone',
      mailbox:'mailbox',
      content:'content',
      firstCatelog:'First Catalog',
      secondCatelog:'Second Catalog',
      contactUs:'Contact us',
      title:'CYX MANAPOWER SERVICE INC',
      partner:'Partner',
      more:'MORE',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/en/index.js